// extracted by mini-css-extract-plugin
module.exports = {"section":"PastSessions_section__mesnL","noResults":"PastSessions_noResults__3LfnK"};